<span class="format-pill d-inline-flex align-items-center rounded-pill gap-1" [style.--pill-color]="'var(' + meta().cssVar + ')'">
  <i class="fa-solid {{ meta().icon }}" aria-hidden="true"></i>
  {{ format() | plusMediaFormat }}
</span>
